<template>
  <section class="section empty-state">
    <p class="section-kicker">404</p>
    <h2>页面不存在</h2>
    <button type="button" class="primary-action compact" @click="front.goPath('/')">返回首页</button>
  </section>
</template>

<script>
export default {
  name: 'NotFoundPage',
  inject: ['front']
}
</script>
